module.exports = __webpack_public_path__ + "img/AUTO_LOUDA.a368c2f2.svg";